<app-loader></app-loader>
<div class="app-container">
    <router-outlet></router-outlet>
</div>
